var $ = require('jQuery');
var Vue = require('vue');
var FieldDisabler = require('../../lib/field-disabler.js');
var PhoneField = require('../../lib/components/Fields/PhoneField.vue').default;
var FileUploadFieldWrapper = require('../../modules/fields/components/FileUploadWrapper').default;
var store = require('../../lib/store/index').default;

module.exports = function() {

  $('#toggle-authenticator').on('change', function () {
    $('#authenticator-link').click();
  });

  // Disable fields without write access
  if (typeof fieldConfig !== 'undefined') {
    var fieldDisabler = new FieldDisabler();

    fieldDisabler.disableFields(fieldConfig.clarify(), 'writeAccess');
  }

  // Covers both `Profile` and `Account fields` tabs
  const phoneWrappers = document.getElementsByClassName('phone-field-wrapper');
  if (phoneWrappers) {
    setTimeout(function () {
      Array.prototype.forEach.call(phoneWrappers, phoneWrapper => {
        new Vue({
          el: phoneWrapper,
          components: {
            'phone-field': PhoneField
          }
        });
      });
    }, 200);
  }

  const fileUploadFieldWrappers = document.getElementsByClassName('upload-field-wrapper');
  if (fileUploadFieldWrappers) {
    Array.prototype.forEach.call(fileUploadFieldWrappers, fileUploadFieldWrapper => {
      new Vue({
        el: fileUploadFieldWrapper,
        components: {
          'file-upload-field-wrapper': FileUploadFieldWrapper,
        },
        store
      });
    });
  }
};
